import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";




const OurBestsellers = () => {
  return (
    <section className="py-md-5 pb-md-0 py-0">

      <div className="newa-letter-box">
        <div class="newsletter-container">
          <h2>Subscribe To Our Newsletter</h2>
          <p>Subscribe to our latest newsletter to get news about special discount.</p>

          <form class="newsletter-form">
            <input type="email" placeholder="Email" required />
            <button type="submit">SUBSCRIBE</button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default OurBestsellers;
